export default function (Component) {
Component.options.__tip = "<p>Use <code>v-padding</code> multiple times to selectively remove padding.</p>\n"
}